module.exports = __webpack_public_path__ + "img/W7026-thumb.acf4ae04.jpg";